module.exports = __webpack_public_path__ + "static/media/navbar-background-mobile.c1e97d9b.jpg";